'use client';
import { getTemplateFullImageUrl } from '@components/Modules/TemplatesModule/utils/urls';
import { useClientConfig } from '@providers/ClientConfigProvider';
import cn from '@utils/cn';
import Image from 'next/image';
import { CSSProperties } from 'react';
import { Size } from '../../utils/types';

type TemplateImageProps = {
  size?: Size;
  width?: number;
  height?: number;
  top?: boolean;
  className?: string;
};

// height and width properties are the maximum height or width of the image

export default function TemplateImage({
  size,
  width = Infinity,
  height = Infinity,
  top = false,
  className,
}: TemplateImageProps) {
  const { CDN_URL } = useClientConfig();
  const style: CSSProperties = {
    maxWidth: size && width < size.width ? `${width}px` : 'auto',
    height: size && height < size.height ? `${height}px` : 'auto',
  };

  return (
    <div className={cn('pointer-events-none relative overflow-hidden', className)} style={style}>
      {size && (
        <Image
          className={cn('block h-full w-full object-contain object-bottom', {
            'object-top': top,
          })}
          src={getTemplateFullImageUrl(size.hash, CDN_URL)}
          loading="lazy"
          height={size.height}
          width={size.width}
          style={{ aspectRatio: size.width / size.height }}
          alt={size.name}
        />
      )}
    </div>
  );
}
